import React, { useState } from 'react';
import logoImage from '../assets/logo_top_quality_rounded.png';

const Navigation = ({ currentPage, navigateTo }) => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

    const colors = {
        primary: '#53354a',
        secondary: '#F5793B',
    };

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    return (
        <nav className="bg-white shadow-md fixed top-0 left-0 right-0 z-50">
            <div className="max-w-6xl mx-auto px-4">
                <div className="flex justify-between items-center py-4">
                    {/* Logo */}
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={() => navigateTo('home')}
                    >
                        <div className="mr-2">
                            <img src={logoImage} alt="ALE Logo" className="w-10 h-10 rounded-full mx-auto" />
                        </div>
                        <div>
                            <div className="font-bold text-2xl" style={{ color: colors.primary, fontFamily: "'Montserrat', sans-serif", letterSpacing: '0.05em' }}>
                                ALE<span style={{ color: colors.secondary }}>.</span>tours
                            </div>
                            <div className="text-xs tracking-wider" style={{ color: colors.secondary, letterSpacing: '0.1em' }}>
                                ASK. LISTEN. EXPLORE.
                            </div>
                        </div>
                    </div>

                    {/* Mobile menu button */}
                    <div className="md:hidden">
                        <button
                            type="button"
                            className="text-gray-600 hover:text-primary focus:outline-none"
                            onClick={toggleMobileMenu}
                        >
                            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                {mobileMenuOpen ? (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                ) : (
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                                )}
                            </svg>
                        </button>
                    </div>

                    {/* Desktop Navigation Links */}
                    <div className="hidden md:flex space-x-8">
                        <button
                            className={`font-medium transition-colors duration-300 ${currentPage === 'home' ? `text-secondary` : `text-gray-600 hover:text-primary`}`}
                            onClick={() => navigateTo('home')}
                        >
                            Home
                        </button>
                        <button
                            className={`font-medium transition-colors duration-300 ${currentPage === 'about' ? `text-secondary` : `text-gray-600 hover:text-primary`}`}
                            onClick={() => navigateTo('about')}
                        >
                            About
                        </button>
                    </div>

                    {/* Desktop CTA Button */}
                    <div className="hidden md:flex">
                        <a
                            href="#download"
                            className="bg-secondary hover:bg-accent3 text-white font-bold py-3 px-6 rounded-lg transition-all"
                        >
                            Download App
                        </a>
                    </div>
                </div>
            </div>

            {/* Mobile Menu */}
            {mobileMenuOpen && (
                <div className="md:hidden bg-white border-t border-gray-200">
                    <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
                        <button
                            className={`block w-full text-left px-3 py-2 rounded-md text-base font-medium ${currentPage === 'home' ? 'bg-gray-100 text-secondary' : 'text-gray-600 hover:bg-gray-50 hover:text-primary'}`}
                            onClick={() => {
                                navigateTo('home');
                                setMobileMenuOpen(false);
                            }}
                        >
                            Home
                        </button>
                        <button
                            className={`block w-full text-left px-3 py-2 rounded-md text-base font-medium ${currentPage === 'about' ? 'bg-gray-100 text-secondary' : 'text-gray-600 hover:bg-gray-50 hover:text-primary'}`}
                            onClick={() => {
                                navigateTo('about');
                                setMobileMenuOpen(false);
                            }}
                        >
                            About
                        </button>
                        <div className="pt-4 pb-3 border-t border-gray-200">
                            <div className="px-3">
                                <a
                                    href="#download"
                                    className="block w-full text-center bg-secondary hover:bg-accent3 text-white font-bold py-2 px-4 rounded-lg transition-all"
                                >
                                    Download App
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </nav>
    );
};

export default Navigation;